require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-kumasi-urban-mobility-and-accessibility-project.json") })
        }
      }, "path---en-us-project-kumasi-urban-mobility-and-accessibility-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-kumasi-urban-mobility-and-accessibility-project!./.cache/json/en-us-project-kumasi-urban-mobility-and-accessibility-project.json
// module id = 534
// module chunks = 231608221292675